import { render } from "./Dictionary.vue?vue&type=template&id=f7e1ef98&scoped=true"
import script from "./Dictionary.vue?vue&type=script&lang=js"
export * from "./Dictionary.vue?vue&type=script&lang=js"

import "./Dictionary.vue?vue&type=style&index=0&id=f7e1ef98&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7e1ef98"]])

export default __exports__